/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { ACCOUNT_VERIFY_LINK, FORGET_PASSWORD_LINK_MESSAGE, LOGIN_SUCCESS, SOME_WENT_WRONG } from "../../../utlis/messages";
import { setEngine } from "crypto";
import { setEmail } from "./authSlice";

const ADMIN_REGISTER_URL = `/auth/signup`
const ADMIN_LOGIN_URL = `/auth/login`
const FORGET_PASSWORD_URL = `/auth/forgotPassword`
const RESEND_VERIFICATION_URL = '/auth/resendVerification'
const VERIFY_PASSWORD_LINK = `/auth/resetLink`
const RESET_PASSWORD_URL = `auth/resetPassword`
const VERIFY_ACCOUNT_LINK = `/auth/verifyAccount`


export const register = createAsyncThunk(
  "auth/signup",
  async ({ values, navigate }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(ADMIN_REGISTER_URL, values);
      successMessage(response.data?.payload?.responseMessage || ACCOUNT_VERIFY_LINK)
      navigate('/auth/login'); 

      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG);

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(ADMIN_LOGIN_URL, values);
      successMessage(response.data?.payload?.responseMessage || LOGIN_SUCCESS)

      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ForgetPasswordAction = createAsyncThunk(
  "forgetPassword",
  async ({ values, navigate }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(FORGET_PASSWORD_URL, values);

      navigate('/auth/reset-link-sent')

      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 403) {
        errorMessage("Your account is not verified. Please check your email for the verification link or request a new one.");
      } else {
        errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG);
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const VerifyPasswordLink = createAsyncThunk(
  "VerifyPasswordLink",
  async ({ id, otp, navigate }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${VERIFY_PASSWORD_LINK}/${id}?otp=${otp}`);
      
      dispatch(setEmail(response.data.data.email));
      successMessage(response.data.responseMessage)
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      navigate('/auth/login')
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ResetPassword = createAsyncThunk(
  "ResetPassword",
  async ({ values, navigate }: any, { rejectWithValue, dispatch, getState }) => {
    try {

      const response = await customAxios('application/json', dispatch).put(`${RESET_PASSWORD_URL}`, values);
      successMessage(response?.data?.responseMessage)
      navigate('/auth/login')
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)

      return rejectWithValue(error?.response?.data);
    }
  }
);

export const VerifyAccountLink = createAsyncThunk(
  "VerifyAccountLink",
  async ({ email, otp, navigate }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`${VERIFY_ACCOUNT_LINK}?email=${email}&otp=${otp}`);
      
      successMessage(response.data.responseMessage)
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ResendVerificationEmail = createAsyncThunk(
  "resendVerification",
  async (values: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).post(RESEND_VERIFICATION_URL, values);
      successMessage(response?.data?.responseMessage || "Verification email sent. Please check your inbox.");
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG);
      return rejectWithValue(error?.response?.data);
    }
  }
);
